"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMaxOnClothSlug = getMaxOnClothSlug;
exports.hasMaxOnClothSlug = hasMaxOnClothSlug;
/** @param { import("../entities/types").Discount } discount */
function hasMaxOnClothSlug(discount) {
  if (typeof discount.maxOnClothSlug === 'undefined') return false;
  return Object.values(discount.maxOnClothSlug).filter(function (max) {
    return max > 0;
  }).length > 0;
}
function getMaxOnClothSlug() {
  var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var discount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _order$clothes = order.clothes,
    clothes = _order$clothes === void 0 ? [] : _order$clothes;
  return clothes.reduce(function (sum, cloth) {
    if (cloth.slug in discount.maxOnClothSlug) {
      return sum + discount.maxOnClothSlug[cloth.slug];
    }
    return sum;
  }, 0);
}